import React from "react";
import { Box, Typography, Tabs, Tab } from "@mui/material";
import PropTypes from "prop-types";
import AdmOverview from "./AdminOverview/AdmOverview";
import AdmProject from "./AdminProj/AdmProject";
import AdmUsers from "./AdminUsers/AdminUsers";
import AdminHr from "./AdminHr/AdminHr";
import AdmTicket from "./AdminTicket/AdminTicket";
import AdmFinance from "./AdminFinance/AdminFinance";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
  },
  "& .MuiTabs-indicatorSpan": {
    maxWidth: 60,
    width: "100%",
    backgroundColor: "#1d82f5",
  },
});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginLeft: theme.spacing(1),
    color: "#C0B476",
    "&.Mui-selected": {
      color: "#000000",
    },
    "&.Mui-focusVisible": {
      backgroundColor: "red",
    },
  })
);

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function AdminDashboard() {
  const [value, setValue] = React.useState(0);
  const userPermissions = useSelector((state) => state?.user?.permissions);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ borderBottom: 1, borderColor: "divider", flexGrow: 1 }}
      >
        <StyledTabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          {userPermissions?.admin_dashboard_overview !== 0 && (
            <StyledTab label="Overview" {...a11yProps(0)} />
          )}
          {userPermissions?.admin_dashboard_project !== 0 && (
            <StyledTab label="Project" {...a11yProps(1)} />
          )}
          {userPermissions?.admin_dashboard_users !== 0 && (
            <StyledTab label="Users" {...a11yProps(2)} />
          )}
          {userPermissions?.admin_dashboard_hr !== 0 && (
            <StyledTab label="HR" {...a11yProps(3)} />
          )}
          {userPermissions?.admin_dashboard_ticket !== 0 && (
            <StyledTab label="Ticket" {...a11yProps(4)} />
          )}
          {userPermissions?.admin_dashboard_finance !== 0 && (
            <StyledTab label="Finance" {...a11yProps(5)} />
          )}
        </StyledTabs>
      </Box>
      <hr></hr>
      <CustomTabPanel value={value} index={0}>
        <AdmOverview />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <AdmProject />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <AdmUsers />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <AdminHr />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={4}>
        <AdmTicket />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={5}>
        <AdmFinance />
      </CustomTabPanel>
    </Box>
  );
}
